class ComingSoonController {
    constructor(translationService) {
        this.translationService = translationService;
    }
}

ComingSoonController.$inject = ['translationService'];

export default ComingSoonController;
